import React from "react";

import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { logOutUser } from "../../redux/actions/UserActions";

// Logo Image
import logo from "../../Images/TPLLogo.png";

// Material UI
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MenuIcon from "@mui/icons-material/Menu";
import Logout from "@mui/icons-material/Logout";

// Utils
import { getStorageValue, setStorageValue } from "../../utility/utils";

// Config
import { appConfig } from "../../utility/config";

// MSAL
import { useMsal } from "@azure/msal-react";

type Props = {
  handleDrawerToggle: () => void;
};

const AdminHeader = ({ handleDrawerToggle }: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loggedInUser = useAppSelector((state) => state.user.loggedIn_User);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const { instance } = useMsal();

  const open = Boolean(anchorEl);

  const handleClick: React.MouseEventHandler<HTMLButtonElement> | undefined = (
    event
  ) => {
    if (event) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRoleSwitch = () => {
    const user = getStorageValue(appConfig.loginUserStorageKey);
    setStorageValue(appConfig.loginUserStorageKey, {
      ...user,
      roleId: loggedInUser.switchRoleId,
      switchRoleId: loggedInUser.roleId,
    });
    navigate("/", { replace: true });
    window.location.reload();
  };

  const handleLogout = async () => {
    dispatch(logOutUser());
    await instance.logoutRedirect();
    navigate("/login", { replace: true });
  };

  return (
    <AppBar
      position="fixed"
      elevation={1}
      sx={{
        backgroundColor: "white",
        color: "black",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar>
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <Stack direction="row" alignItems="center">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Box
              sx={{
                width: { xs: "100px", sm: "170px" },
                marginRight: loggedInUser.switchRoleId ? "1em" : 0,
              }}
            >
              <img src={logo} width="100%" alt="Logo" />
            </Box>
            {loggedInUser.switchRoleId ? (
              <Button
                variant="contained"
                color="primary"
                onClick={handleRoleSwitch}
              >
                {loggedInUser.roleName}
              </Button>
            ) : null}
          </Stack>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              endIcon={<KeyboardArrowDown />}
              color="inherit"
              onClick={handleClick}
            >
              <Avatar alt="user avatar">
                <PersonOutlineIcon />
              </Avatar>
            </Button>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;
